import { useMutation, useQueryClient } from '@tanstack/react-query';
import { banAppUser } from '../services/appUsers';
import { appUsersQueryKeys } from './query-keys';

export const useBanAppUserMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (userId) => {
      const result = await banAppUser(userId);
      if (!result.success) {
        throw new Error(result.message || 'Failed to ban user');
      }
      return result;
    },
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({ queryKey: appUsersQueryKeys.all });
      options.onSuccess?.(...args);
    },
    ...options,
  });
};
